<app-loading-spinner *ngIf="isLoading" [inline]="1"></app-loading-spinner>
<nav class="subnav">
  <h2>Feel Well Tracker</h2>
</nav>

<div class="container container-inner" *ngIf="userData">
  <button
    class="btn btn-primary w-100 mt-4"
    [routerLink]="['/modules', 'feel-well', 'add-entry']"
  >
    <span class="icon-wrap"
      ><fa-icon [icon]="['fas', 'circle-plus']"></fa-icon
    ></span>
    Add A Daily Entry
  </button>

  <div class="row">
    <div class="col-12 col-md-6">
      <div class="weeks-nav mt-4 mb-1" *ngIf="allWeeksData && showWeek > 0">
        <div class="prevnext">
          <button
            (click)="onPrevWeek()"
            *ngIf="showWeek > 1"
            class="btn btn-link"
          >
            <span class="icon-wrap duo-primary-dark"
              ><fa-icon
                [icon]="['fad', 'chevron-circle-left']"
                aria-label="Previous week"
              ></fa-icon
            ></span>
          </button>
        </div>
        <div class="weeks-nav-title">
          <h4 class="text-center" *ngIf="userWeek">WEEK {{ showWeek }}</h4>
          <div>
            {{
              allWeeksData[userWeek - showWeek][0].date
                | customDate : "ddd Do MMM"
            }}
            -
            {{
              allWeeksData[userWeek - showWeek][6].date
                | customDate : "ddd Do MMM"
            }}
          </div>
        </div>
        <div class="prevnext">
          <button
            (click)="onNextWeek()"
            *ngIf="showWeek < userWeek"
            class="btn btn-link"
          >
            <span class="icon-wrap duo-primary-dark"
              ><fa-icon
                [icon]="['fad', 'chevron-circle-right']"
                aria-label="Next week"
              ></fa-icon
            ></span>
          </button>
        </div>
      </div>

      <div class="card bg-dark text-white">
        <div class="card-body">
          <table class="tracker-table">
            <thead>
              <tr>
                <th></th>
                <th *ngFor="let day of allWeeksData[userWeek - showWeek]">
                  {{ day.date | customDate : "ddd" }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <span class="icon-wrap"
                    ><fa-icon [icon]="['fas', 'face-smile-relaxed']"></fa-icon
                  ></span>
                </td>
                <td *ngFor="let day of allWeeksData[userWeek - showWeek]">
                  <span
                    class="circle circle-sm circle-lighten"
                    *ngIf="day.hasData"
                    >{{ day.score }}</span
                  >
                  <span *ngIf="day.date > today || !day.hasData">-</span>
                </td>
              </tr>
            </tbody>
          </table>

          <div
            class="tracker-stats mt-2 mb-2"
            *ngIf="allWeeksData[userWeek - showWeek]"
          >
            <div
              class="card-total card-total-inline card-total-light card-total-lg card-total-nb bg-white text-dark"
            >
              <div class="card-total-title">Average Score</div>
              <span>{{
                userFeelService.getWeekScore(allWeeksData[userWeek - showWeek])
                  .average
              }}</span>
            </div>
          </div>

          <hr />
          <div class="text-center">
            <button
              class="btn btn-link btn-link-nd text-white"
              (click)="showBreakdown = !showBreakdown"
            >
              Full Breakdown
              <span class="icon-wrap"
                ><fa-icon
                  *ngIf="showBreakdown"
                  [icon]="['fas', 'chevron-circle-up']"
                ></fa-icon
                ><fa-icon
                  *ngIf="!showBreakdown"
                  [icon]="['fas', 'chevron-circle-down']"
                ></fa-icon
              ></span>
            </button>

            <div class="breakdown" *ngIf="showBreakdown">
              <table class="tracker-table">
                <thead>
                  <tr>
                    <th></th>
                    <th>Mood</th>
                    <th>Worry</th>
                    <th>Stress</th>
                    <th>Score</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let day of allWeeksData[userWeek - showWeek]">
                    <td>
                      {{ day.date | customDate : "ddd" }}
                    </td>

                    <td><span
                        class="circle circle-sm circle-lighten"
                        *ngIf="day.hasData"
                        >{{ day.mood }}</span
                      >
                        <span *ngIf="!day.hasData">-</span>
                    </td>
                    <td><span
                        class="circle circle-sm circle-lighten"
                        *ngIf="day.hasData"
                        >{{ day.worry }}</span
                      >
                      <span *ngIf="!day.hasData">-</span></td>
                    <td><span
                        class="circle circle-sm circle-lighten"
                        *ngIf="day.hasData"
                        >{{ day.stress }}</span
                      >
                      <span *ngIf="!day.hasData">-</span></td>
                    <td><span
                        class="circle circle-sm circle-lighten"
                        *ngIf="day.hasData"
                        >{{ day.score }}</span
                      >
                      <span *ngIf="!day.hasData">-</span></td>

                    <td width="18">
                      <span
                        class="icon-wrap"
                        dropdown
                        [container]="'body'"
                        *ngIf="day.hasData"
                      >
                        <button
                          dropdownToggle
                          type="button"
                          class="btn text-white"
                          aria-controls="dropdown-basic"
                        >
                          <fa-icon [icon]="['fas', 'ellipsis-v']"></fa-icon>
                        </button>
                        <ul
                          *dropdownMenu
                          class="dropdown-menu dropdown-menu-right"
                          role="menu"
                          aria-labelledby="button-basic"
                        >
                          <li role="menuitem">
                            <a
                              class="dropdown-item"
                              [routerLink]="[
                                '/modules',
                                'feel-well',
                                'edit-entry',
                                day.entryId
                              ]"
                              >Edit</a
                            >
                          </li>
                          <li role="menuitem">
                            <a
                              class="dropdown-item"
                              (click)="onDeleteEntry(day.entryId)"
                              >Delete</a
                            >
                          </li>
                        </ul>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>Avg.</td>
                    <td>
                        <span
                        class="circle circle-sm circle-lighten"
                        >
                      {{
                        userFeelService.getWeekAvg(
                          allWeeksData[userWeek - showWeek],
                          "mood"
                        )
                      }}</span>
                    </td>
                    <td>
                        <span
                        class="circle circle-sm circle-lighten"
                        >
                      {{
                        userFeelService.getWeekAvg(
                          allWeeksData[userWeek - showWeek],
                          "worry"
                        )
                      }}</span>
                    </td>
                    <td>
                        <span
                        class="circle circle-sm circle-lighten"
                        >
                      {{
                        userFeelService.getWeekAvg(
                          allWeeksData[userWeek - showWeek],
                          "stress"
                        )
                      }}
                      </span>
                    </td>
                    <td>
                        <span
                        class="circle circle-sm circle-lighten bg-white text-dark"
                        >
                      {{
                        userFeelService.getWeekScore(
                          allWeeksData[userWeek - showWeek]
                        ).average
                      }}
                      </span>
                    </td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6">
      <h3 class="title-xl text-center mt-3">All Time</h3>

      <div class="card bg-light">
        <div class="card-body">
          <h4 class="text-center">Average Score</h4>
          <div class="stat">
            <div class="days-indicator days-indicator-md text-center">
              <div
                class="day"
                *ngFor="
                  let week of allWeeksData.slice().reverse();
                  let i = index
                "
              >
                <div class="day-label">W{{ i + 1 }}</div>
                <div class="day-status-lg day-status-circle bg-dark">
                  <div class="day-status-title">
                    {{ userFeelService.getWeekScore(week).average }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
